import { Auth3L } from "@/lib-vue/autodesk/client.js";
import { CLIENT_ID, REDIRECT_URL } from "@/lib-vue/config/autodesk.config.js";
import { UrlBuilder } from "@/lib-vue/js/UrlBuilder.js";

function authenticate() {
  Auth3L.clear();
  const scopes = ['account:read', 'data:read', 'data:create'];
  Auth3L.authenticate(scopes);
}

function isAuthenticated() {
  return Auth3L.authenticated(codeExchangeFunction);
}

function logout() {
  Auth3L.clear();
  const url = new UrlBuilder(window.location.href).clear_all().as_href();
  window.location.href = url;
}

function redirect(pathname, delay) {
  setTimeout(() => {
    const url = new UrlBuilder(window.location.href)
                    .clear_all()
                    .set_pathname(pathname)
                    .as_href();
    window.location.href = url;
  }, delay);
}

function redirectIndex() {
  redirect('', 500)
}

function codeExchangeFunction(authCode, codeVerifier) {
  const url = new UrlBuilder(window.location.href)
                  .clear_all()
                  .set_pathname('/api/auth')
                  .as_href();
  const body = JSON.stringify({
    "clientId": CLIENT_ID, 
    "redirectUri": REDIRECT_URL,
    "authCode": authCode,
    "codeVerifier": codeVerifier
  });
  return fetch(url, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Authorization": "anonymous",
    },
    body })
  .then(r => r.json())
  .then(data => {if ('access_token' in data) {return data.access_token}
    else {throw Error('token not in object')}}
  )
}

export { isAuthenticated, authenticate, logout, redirect, redirectIndex, codeExchangeFunction }

